import { Card, Spinner } from 'react-bootstrap';
import { Doughnut } from 'react-chartjs-2';

import { Chart, ChartLegend } from '../components/vendor/Chart';
import { currencyFormatter } from '../helpers/currencyFormatter';
import { RevenueByTypeResponse } from '../types/dashboard';

const CHART_BODY_MIN_HEIGHT = 300;

// Colour palette for order type segments
const SEGMENT_COLORS = ['#2C7BE5', '#A6C5F7', '#D2DDEC', '#E3EBF6', '#95AAC9'];

interface AnalyticsTrafficChannelsProps {
  data?: RevenueByTypeResponse;
  isLoading?: boolean;
}

export default function AnalyticsTrafficChannels({ data, isLoading, ...props }: AnalyticsTrafficChannelsProps) {
  const segments = data?.segments ?? [];
  const hasData = !isLoading && segments.length > 0;

  const labels = segments.map(s => s.label);
  const values = segments.map(s => s.value);
  const bgColors = segments.map((_, i) => SEGMENT_COLORS[i % SEGMENT_COLORS.length]);

  const chartDatasets = [
    {
      data: values,
      backgroundColor: bgColors
    }
  ];

  const options = {
    plugins: {
      tooltip: {
        callbacks: {
          afterLabel: function () {
            return '';
          },
          label: function (ctx: any) {
            const val = ctx.parsed;
            return ' ' + currencyFormatter(val);
          }
        }
      }
    }
  };

  return (
    <Card {...props}>
      <Card.Header>
        <h4 className="card-header-title">Revenue by Order Type</h4>
      </Card.Header>
      <Card.Body
        style={{ minHeight: CHART_BODY_MIN_HEIGHT }}
        className="d-flex align-items-center justify-content-center"
      >
        {isLoading ? (
          <Spinner animation="border" />
        ) : hasData ? (
          <div className="w-100">
            <Chart layout="appended">
              <Doughnut data={{ labels, datasets: chartDatasets }} options={options} />
            </Chart>
            <ChartLegend data={{ labels, datasets: chartDatasets }} />
          </div>
        ) : (
          <p className="text-muted text-center mb-0">No data available</p>
        )}
      </Card.Body>
    </Card>
  );
}
